import { useQuery } from 'convex/react';
import { api } from '../convex/_generated/api';
import { useAuthData } from './useAuthData';

export function useUserVisitedRestaurants() {
  const { authData } = useAuthData();

  return useQuery(
    api.memberships.getUserVisitedRestaurants,
    authData?.privyDid ? { privyDid: authData.privyDid } : 'skip'
  );
}
